import { useEffect, useState } from 'react'

const SP_BREAKPOINT = 768

const useIsSp = (breakpoint = SP_BREAKPOINT) => {
  const [isSp, setIsSp] = useState(() => window.innerWidth < breakpoint)

  useEffect(() => {
    const handleResize = () => setIsSp(window.innerWidth < breakpoint)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isSp
}

export default useIsSp
